export default __webpack_public_path__ + "static/media/NW0040.34I-39541_-25350_0.fd366055.jpg";